import React, { Component } from 'react'

import NumbersForm from '../NumbersForm'
import NumbersTwilioForm from '../NumbersTwilioForm'

export default class NumbersFormModal extends Component {
  static defaultProps = {
    numberType: '1300',
  }

  render() {
    const {
      productName,
      numberType,
      productId,
      modalCancel,
      premiumNumber,
      standardNumber,
      premiumNumberMonthlyFee,
      numberSelected,
      numberWithLetters,
    } = this.props

    return (
      <div>
        {numberType === 'local' || numberType === 'mobile' || numberType === 'global' ? (
          <NumbersTwilioForm
            numberType={numberType}
            onCancel={modalCancel}
            initialSearchValue={numberSelected}
            heading={`Signup for a ${numberType} Number`}
            subHeading={"This won't take much more than 5 minutes."}
          />
        ) : (
          <NumbersForm
            numberType={numberType}
            premiumNumber={premiumNumber}
            standardNumber={standardNumber}
            productId={productId}
            productName={productName}
            premiumNumberMonthlyFee={premiumNumberMonthlyFee}
            numberSelected={numberSelected}
            numberWithLetters={numberWithLetters}
            onCancel={modalCancel}
            heading={"Now that's a Classic, well it will be!"}
            subHeading={'Just a few more minutes should do it!'}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersFormModal/NumbersFormModal.jsx